import type { ITVCardRoundedProps } from './TVCardRounded'

import { styled } from '@linaria/react'
import { FallbackImageSC } from 'atoms/FallbackImage'
import { CORNERS } from 'vars/index'
import { PosterContainerSC } from '../base-card'
import { Card } from '../Card'

export const CardStyled = styled(Card)<{
  corners: ITVCardRoundedProps['corners']
}>`
  border-radius: var(${CORNERS.CORNERS_0});

  &:before {
    border-radius: ${({ corners }) => `var(${corners})`};
  }

  ${PosterContainerSC}, ${FallbackImageSC} {
    border-radius: ${({ corners }) => `var(${corners})`};
  }

  ${PosterContainerSC} {
    overflow: hidden;
  }
`
